import React, { useRef,useState,useEffect } from "react";
import { useHistory } from "react-router-dom";
import {motion} from "framer-motion";
import {useSelector,useDispatch} from 'react-redux'
import {setWorkExp} from '../actions'
import Work from './Work'

const contVariant={
  hidden:{
    x:"100vw"
  },
  visible:{
    x:0,
    transition:{
      delay:0.1,
      type:"spring",
      stiffness:80,
      mass:0.4,
      damping:8
    }
  }
}
const linkVariant={
  hover:{
    textShadow: "2px 2px 10px rgba(0,0,0,0.8)",
    boxShadow:"2px 2px 10px rgba(0,0,0,0.8)",
    transition:{
      duration:0.2
    }
  }
}
export default function WorkExp() {
  const resumeWorks=useSelector(states=>states.resumeData).workExp
  const [works,setResumeWorks]=useState(()=>{
    return resumeWorks
  })
  const dispatch=useDispatch()
  const history = useHistory();
  const [company,title,desc] = [
    useRef(""),
    useRef(""),
    useRef("")
  ];
  function handleSubmit(e) {
    e.preventDefault();
    dispatch(setWorkExp(works))
    history.push("/add-project-details");
  }
  function addWork(e){
    e.preventDefault();
    setResumeWorks((prevWorks)=>{
      return [...prevWorks,{company:company.current.value,title:title.current.value,desc:desc.current.value}]
    })
  }
  function removeWork(id){
    setResumeWorks((prevWorks)=>{
      return prevWorks.filter((work,index)=>index!==id)
    })
  }
  useEffect(()=>{
    company.current.value=''
    title.current.value=''
    desc.current.value=''
  },[works])
  return (
    <motion.div className="container" exit={{x:"-100vw"}}>
      <motion.div className="form"
        variants={contVariant}
        initial="hidden"
        animate="visible"
      >
        <h1><i className="mr-2 fas fa-briefcase"></i>Work Experience or Internships</h1>
        <div className="recommendation">If you do not work for any company, you can type 'Independent' in company & job title field</div>
        <form onSubmit={addWork}>
          <input type="text" ref={company} placeholder="Company" required />
          <input
            type="text"
            ref={title}
            placeholder="Job title"
            required
          />
          <input type="text" ref={desc} placeholder="Job description" required />
          <motion.button variants={linkVariant} whileHover="hover" type="submit">add</motion.button>
        </form>
        <ul>
          {works.map((work,index)=>{
            return (<Work work={work} key={index} id={index} removeWork={removeWork} />)
          })}
        </ul>
        {works==0 && <motion.button variants={linkVariant} whileHover="hover" className="save-btn" onClick={handleSubmit}>fresher</motion.button>}
        {works!=0 && <motion.button variants={linkVariant} whileHover="hover" className="save-btn" onClick={handleSubmit}>save & next</motion.button>}
      </motion.div>
    </motion.div>
  );
}
